
import angular from "angular";

import RequestToken from "./RequestToken";

const mLogSvc = new WeakMap();

class OpToken extends RequestToken {
    constructor($log, operationName, operationParameters) {
        super("opToken");

        if ($log != null) {
            mLogSvc.set(this, $log);
        }
        else {
            throw new Error("Missing log service dependency");
        }

        let externalParams = undefined;
        if (operationParameters != null)
        {
            externalParams = {};
        }
        else {
            externalParams = operationParameters;
        }

        this._tokenParams = angular.extend({
            opType: operationName
        }, externalParams);
    }

    /* override */
    toString() {
        return "OpToken (" + this._tokenParams.opType + ")";
    }

    /* override */
    toSearchRequest(childRequests) {
        if (angular.isArray(childRequests) && (childRequests.length === 2)) {
            if ((childRequests[0] == null) || (childRequests[1] == null)) {
                return null;
            }

            return {
                operation: this._tokenParams.opType,
                operands: childRequests
            };
        }
        else {
            mLogSvc.get(this).error("Invalid Search Request: Operation " + this._tokenParams.opType + " does not have 2 arguments.");
            return null;
        }
    }
}

export default OpToken;



//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/OpToken.js
// module id = KTcc
// module chunks = 1